import _Vue from "vue"

class RecordEvent {
  public install(Vue: typeof _Vue) {
    Vue.prototype.$recordEvent = (eventName: string, details: Record<string, any> = {}) => {
      // Vercel Analytics disabled - Samsung TV compatibility issue
      // Only track in production to avoid noise in analytics
      if (process.env.NODE_ENV === 'production') {
        console.log('[Analytics]', eventName, details);

      } else {
        console.log('[Analytics]', eventName, details);
      }
    }
  }
}

export default new RecordEvent() ;
